import { useMsal } from '@azure/msal-react';
import { FC, PropsWithChildren, createContext, useContext, useEffect, useState } from 'react';
import { logout } from '../Security/azureAdAuthentication';
// import { getUserPhoto } from '../GraphApi';

export type UserProfile = {
    username: string; // it contains the email, e.g. name.surname@syensqo.com
    name?: string;
    photo?: string;
};

export type UserContextType = {
    userProfile?: UserProfile;
    clearUserProfile: () => void;
};

export const UserContext = createContext<UserContextType | undefined>(undefined);

const UserContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [userProfile, setUserProfile] = useState<UserProfile | undefined>(undefined);
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    
    // If the authenticated user is not from Syensqo (e.g. Solvay), we log them out
    if (activeAccount && !activeAccount.username.endsWith("@syensqo.com")){
        logout();
    }

    useEffect(() => {
        if (activeAccount && !userProfile) {
            // getUserPhoto().then((photo) => {
                setUserProfile({
                    username: activeAccount.username,
                    name: activeAccount.name
                    // photo,
                });
            // });
        }
    }, [activeAccount, instance, userProfile]);
    const clearUserProfile = () => setUserProfile(undefined);
    return <UserContext.Provider value={{ clearUserProfile, userProfile }}>{children}</UserContext.Provider>;
};

export default UserContextProvider;

export const useUserContext = () => useContext(UserContext) as UserContextType;
